const PRODUCTION_PROJECT_REF = 'ziwvzqwbgebcmxiudvfi'
const STAGING_PROJECT_REF = 'eixvhibsofdrweejnjok'

function projectRef(value: string): string | null {
  try {
    const url = new URL(value.trim())
    if (url.protocol !== 'https:' || url.username || url.password || url.port || url.pathname !== '/' || url.search || url.hash) return null
    return url.hostname.match(/^([a-z0-9]{20})\.supabase\.co$/)?.[1] || null
  } catch {
    return null
  }
}

export function assertBrowserEnvironmentBoundary(environment: string, supabaseUrl: string, workspaceId: string): void {
  const identity = environment.trim().toLowerCase()
  const ref = projectRef(supabaseUrl)
  if (!['production', 'staging'].includes(identity)) throw new Error('environment_identity_missing')
  if (!ref || !workspaceId.trim()) throw new Error('browser_environment_boundary_invalid')
  if (identity === 'production' && ref !== PRODUCTION_PROJECT_REF) throw new Error('production_project_mismatch')
  if (identity === 'staging' && ref !== STAGING_PROJECT_REF) throw new Error('staging_project_mismatch')
}
